export const stageApi = {
  fetchStageList: (): string => `/api/portal/staff/medical/doctor/stages`,
  fetchStageQueue: (id: string): string =>
    `/api/portal/staff/patients/${id}/stages/patient-queue`,
  createStageQueue: (): string => `/api/portal/staff/medical/doctor/stages`,
  deleteStageQueue: (stageId: string): string =>
    `/api/portal/staff/medical/doctor/stages/${stageId}`,
};
